import { Button } from "@mantine/core";
import { observer } from "mobx-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { RichText } from "../../custom-components/rich-text-editor";
import { QueryKeys } from "../../models/models";
import t from "../../stores/language";
import { useQuery, useStore } from "../../stores/store";
import { useStyles } from "./configure-input";

export const delay = (ms: number): Promise<never> => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export const ModuleAssumptions = observer(function ModuleDescription() {
  const { classes } = useStyles();
  const [saving, setSaving] = useState<boolean>(false);
  const { id } = useParams();
  const { store } = useStore();
  const [description, setDescription] = useState<string>("");
  useQuery({
    queryKey: [QueryKeys.Assumptions, id],
    queryFn: () => {
      return store.GetAssumptionsByModuleId(id ?? "0");
    },
    onSuccess: (result) => {
      setDescription(result);
    },
  });
  const saveAssumptions = async () => {
    setSaving(true);
    await delay(250);
    try {
      await store.UpdateModuleAssumptions(parseInt(id ?? "0"), description);
      setSaving(false);
    } catch {
      setSaving(false);
    }
  };
  return (
    <>
      <div className={classes.title}>
        <span>{t("Standard Assumptions")} </span>
        <Button onClick={() => saveAssumptions()} loading={saving}>
          Save
        </Button>
      </div>
      <RichText
        content={description}
        onChange={(v) => {
          setDescription(v);
        }}
      />
    </>
  );
});
